// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"297646c9","136":"6694c482","423":"558a65a7","630":"59c4b1dc","797":"87876eb6","894":"208ea6e4"}[chunkId] + ".chunk.js";
};